/* メインビジュアル underlay controller の ready 待機と fallback だけを扱う */
(() => {
  function registerMainVisualSyncMembers(syncMembers) {
    const registerSyncMembers = window.AuremeMainVisual?.registerSyncMembers;
    if (typeof registerSyncMembers === 'function') return registerSyncMembers(syncMembers);

    window.AuremeMainVisual = window.AuremeMainVisual || {};
    window.AuremeMainVisual.pendingSyncMembers = window.AuremeMainVisual.pendingSyncMembers || [];
    window.AuremeMainVisual.pendingSyncMembers.push(syncMembers);

    return null;
  }

  const Sync = window.AuremeMainVisual?.Sync || {};

  if (Sync.MainVisualUnderlayReadySync) {
    /* section 再描画などの再評価時は、登録済み constructor をそのまま使う */
    return;
  }

  /* contract.js の DEFAULT_CONSTANTS と同じ値にし、先後どちらの評価順でも同じ ready 待機にする */
  const {
    UNDERLAY_READY_EVENT = 'aureme:main-visual-underlay:ready',
    UNDERLAY_READY_CLASS = 'aureme-main-visual-underlay-ready',
  } = Sync.constants || {};
  const UNDERLAY_READY_FALLBACK_DELAY = 1500;

  function toggleMainVisualUnderlayReadyClass(element, isReady) {
    if (!element) return;
    element.classList.toggle(UNDERLAY_READY_CLASS, isReady);
  }

  function updateMainVisualUnderlayReadyState(sectionElement, headerSection, isReady) {
    toggleMainVisualUnderlayReadyClass(headerSection, isReady);
    toggleMainVisualUnderlayReadyClass(sectionElement, isReady);
  }

  function getMainVisualUnderlaySyncConstructor() {
    return window.AuremeMainVisualUnderlay?.UnderlaySync || null;
  }

  function runWhenMainVisualUnderlayReady(callback) {
    const UnderlaySync = getMainVisualUnderlaySyncConstructor();
    if (UnderlaySync) {
      callback(UnderlaySync);
      return null;
    }

    const handleUnderlayReady = () => {
      const ReadyUnderlaySync = getMainVisualUnderlaySyncConstructor();
      if (!ReadyUnderlaySync) return;

      callback(ReadyUnderlaySync);
    };

    /* section 再描画では script の再評価順が揺れるため、underlay controller の公開を待つ */
    window.addEventListener(UNDERLAY_READY_EVENT, handleUnderlayReady, { once: true });
    return () => window.removeEventListener(UNDERLAY_READY_EVENT, handleUnderlayReady);
  }

  class MainVisualUnderlayReadySync {
    constructor({ sectionElement, headerSection, underlayColorSources, requestSync }) {
      this.sectionElement = sectionElement;
      this.headerSection = headerSection;
      this.underlayColorSources = underlayColorSources;
      this.requestSync = requestSync;
      this.cancelUnderlayReadyWait = null;
      this.hasUnderlayReadyFallback = false;
      this.underlayReadyFallbackTimeout = null;
      this.underlaySync = null;
    }

    connect() {
      this.cancelUnderlayReadyWait = runWhenMainVisualUnderlayReady((UnderlaySync) => {
        this.cancelUnderlayReadyWait = null;
        this.initializeUnderlaySync(UnderlaySync);
      });

      if (!this.underlaySync) {
        this.scheduleUnderlayReadyFallback();
      }
    }

    disconnect() {
      this.cancelUnderlayReadyWait?.();
      this.cancelUnderlayReadyWait = null;
      this.cancelUnderlayReadyFallback();

      if (!this.underlaySync && this.hasUnderlayReadyFallback) {
        updateMainVisualUnderlayReadyState(this.sectionElement, this.headerSection, false);
      }

      this.hasUnderlayReadyFallback = false;
      this.underlaySync?.clear();
    }

    reset() {
      if (this.underlaySync) {
        this.underlaySync.reset();
        return;
      }

      if (this.hasUnderlayReadyFallback) {
        updateMainVisualUnderlayReadyState(this.sectionElement, this.headerSection, false);
        this.hasUnderlayReadyFallback = false;
      }

      this.scheduleUnderlayReadyFallback();
    }

    sync(activeMedia, hasMediaForActiveBreakpoint) {
      this.underlaySync?.sync(activeMedia, hasMediaForActiveBreakpoint);
    }

    initializeUnderlaySync(UnderlaySync) {
      if (this.underlaySync) return;

      this.cancelUnderlayReadyFallback();
      this.hasUnderlayReadyFallback = false;
      this.underlaySync = new UnderlaySync(this.sectionElement, this.headerSection);
      this.underlaySync.reset();
      this.underlaySync.syncUnderlayColors(this.underlayColorSources);
      this.requestSync();
    }

    scheduleUnderlayReadyFallback() {
      this.cancelUnderlayReadyFallback();

      /*
       * Underlay controller が遅延しても main visual を表示可能にし、
       * 後から controller が届いた場合は fallback を取り消して実同期へ移す。
       */
      this.underlayReadyFallbackTimeout = window.setTimeout(() => {
        this.underlayReadyFallbackTimeout = null;
        if (this.underlaySync) return;

        this.hasUnderlayReadyFallback = true;
        updateMainVisualUnderlayReadyState(this.sectionElement, this.headerSection, true);
      }, UNDERLAY_READY_FALLBACK_DELAY);
    }

    cancelUnderlayReadyFallback() {
      if (!this.underlayReadyFallbackTimeout) return;

      window.clearTimeout(this.underlayReadyFallbackTimeout);
      this.underlayReadyFallbackTimeout = null;
    }
  }

  registerMainVisualSyncMembers({
    MainVisualUnderlayReadySync,
  });
})();
